import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { Resolutions } from "@resolutions";
import { WindowRefService } from "@service/window-service/window-ref.service";
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface SplitSectionInterface
{
  left: {
    type: string;
    content: any;
  },
  right: {
    type: string;
    content: any;
  },
  ratio: {
    desktop: number;
    desktopMinWidthLeft: number;
    desktopMinWidthRight: number;
    tablet: number;
    tabletMinWidthLeft: number;
    tabletMinWidthRight: number;
  },
  anchor?: string,
  rightAboveLeft?: boolean
}

@Component({
    selector: 'app-split-section',
    templateUrl: './split-section.component.html',
    styleUrls: ['./split-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SplitSectionComponent implements OnInit
{

  @Input() section: SplitSectionInterface;
  @Input() type: string;
  @Input() margin: BlockMargin;

  public gridTemplateColumns;
  public minWidthLeft = 0;
  public minWidthRight = 0;

  constructor(public changeDet: ChangeDetectorRef, private windowRef: WindowRefService, public marginService: MarginService) { }

  ngOnInit(): void
  {
    this.calculateSectionsWidth();
  }

  private calculateSectionsWidth()
  {
    if (this.windowRef.getNativeWindowInnerWidth() < Resolutions.resolutionTablet)
    {
      this.gridTemplateColumns = `unset`;
      return;
    }

    let leftWidth = 50;

    if (this.section.ratio)
    {
      if (this.windowRef.getNativeWindowInnerWidth() >= Resolutions.resolutionTablet)
      {
        leftWidth = this.section.ratio.tablet || 50;
        if (this.section.ratio.tabletMinWidthLeft && this.section.ratio.tabletMinWidthLeft > 0)
        {
          this.minWidthLeft = this.section.ratio.tabletMinWidthLeft;
        } else if (this.section.ratio.tabletMinWidthRight && this.section.ratio.tabletMinWidthRight > 0)
        {
          this.minWidthRight = this.section.ratio.tabletMinWidthRight;
        }
      }
      else if (this.windowRef.getNativeWindowInnerWidth() >= Resolutions.resolutionDesktop)
      {
        leftWidth = this.section.ratio.desktop || 50;
        if (this.section.ratio.desktopMinWidthLeft && this.section.ratio.desktopMinWidthLeft > 0)
        {
          this.minWidthLeft = this.section.ratio.desktopMinWidthLeft;
        } else if (this.section.ratio.desktopMinWidthRight && this.section.ratio.desktopMinWidthRight > 0)
        {
          this.minWidthRight = this.section.ratio.desktopMinWidthRight;
        }
      }
    }

    const rightWidth = 100 - leftWidth;
    this.gridTemplateColumns = `${leftWidth}fr ${rightWidth}fr`;
  }

  @HostListener("window:resize", ["$event"])
  private onResize(): void
  {
    this.calculateSectionsWidth();
    this.changeDet.detectChanges();
  }
}
